import { Component, OnInit, Input } from '@angular/core';
import { GatemanService } from '../../services/gateman.service';
import { PopoverController } from '@ionic/angular';
import { PopoverComponent  } from "../popover/popover.component";
@Component({
  selector: 'app-button-segments',
  templateUrl: './button-segments.component.html',
  styleUrls: ['./button-segments.component.scss']
})
export class ButtonSegmentsComponent implements OnInit {

  @Input() config: {
    class: string,
    segments: [
            {
              title: string,
              icon: string | Array<string>,
              link: string,
              tooltip?: string,
              tooltipClass?: string
            }],
   
  };
  constructor(public gatemanService: GatemanService, private popoverController : PopoverController) { }

  /**
   * @task QLIKTAG-2975
   * @author Lalitkumar Saindane
   */
  ngOnInit() {
  }

  /**
   * show popover on click
   * @param ev [event]
   * @param text [tooltip text]
   * @author Radhika Agnihotri
   * @task  QLIKTAG-3397
   */
  async presentPopover(ev: MouseEvent, text?: string, tooltipClass?: string) {
    //console.log("mouseenter")
    //console.log(this.config,"config")
    if(text && text != '') {
      const popover = await this.popoverController.create({
        component: PopoverComponent,
        event: ev,
        componentProps: {
          'text': text
        },
        showBackdrop: false,
        cssClass: tooltipClass ? tooltipClass : 'segment-tooltip',
        mode: "ios"
      });   
      return await popover.present();
    }
  }

 
}
